/** Default MotiSig AI client API base URL. */
export const DEFAULT_MOTISIG_BASE_URL = 'https://api.motisig.ai/client';
